import { translate } from '../../../../../common/i18n';

Blockly.Blocks.is_virtual = {
    init: function init() {
        this.appendDummyInput().appendField(translate('Is Virtual Trade'));
        this.setOutput(true, 'Boolean');
        this.setColour('#f2f2f2');
        this.setTooltip(
            translate(
                'True if the active trade is a virtual trade. When used inside the After Purchase block, it will detect the latest trade.'
            )
        );
    },
    onchange: function onchange() {},
};

Blockly.JavaScript.is_virtual = () => [
    'BinaryBotPrivateVirtualSettings.ongoing && BinaryBotPrivateVirtualSettings.active && Bot.isVirtualValid()',
];
